module.exports = __webpack_public_path__ + "static/media/Comp-1.dfbab99f.gif";